var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"ins-tabs"},_vm._l((_vm.tabs),function(t){return _c('a',{key:t.id,class:{ active: _vm.value === t.id },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('input', t.id)}}},[_vm._v(_vm._s(t.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }